import React from 'react'
import { StaticQuery, graphql, Link } from 'gatsby'
import uuid from 'uuid'

import BgImage from '../BgImage'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronLeft } from '@fortawesome/free-solid-svg-icons'


import './style.sass'

const RelatedActivities = ({active_id}) => (
  <StaticQuery
    query={graphql`
      query RelatedActivities {
        allMarkdownRemark (
          limit: 10
          filter: {
            frontmatter: {type: {eq: "Activity"}}
          }
          sort: { order: DESC, fields: [frontmatter___date]}
        ) {
          edges {
            node {
              id
              frontmatter {
                title
                type
                path
                price
                duration
                thumb {
                  childImageSharp {
                    fluid(quality: 100, maxWidth: 530, maxHeight: 210) {
                      ...GatsbyImageSharpFluid_withWebp
                    }
                  }
                }
              }
            }
          }
        }
      }
    `}

    render={data => (
      <div className="related-activities-wrapper">
        <div className="related-activities-title">Other activities</div>
        <ul className="related-activities">
          {data.allMarkdownRemark.edges.map(({ node }) => (
            <li
              className={"related-activity"+( node.id === active_id ? ' is-active': '')}
              key={uuid.v4()}
            >
              <Link
                to={node.frontmatter.path}
                onClick={() => {
                  document.body.classList.remove('show-sidebar')
                }}
              >
                <div className="related-activity-pic-wrapper">
                  <span className="chevron-left">
                    <FontAwesomeIcon icon={faChevronLeft} />
                  </span>  
                  <BgImage image={node.frontmatter.thumb} className="related-activity-pic"/>
                </div>
                <div className="related-activity-title">{node.frontmatter.title}</div>
                <div className="related-activity-price">{node.frontmatter.price} / {node.frontmatter.duration}</div>
              </Link>
            </li>
          ))}
        </ul>
      </div>
    )}
  
  />
)

export default RelatedActivities

